import React, { useEffect, useState } from 'react';
import { ColumnDef } from '@tanstack/react-table';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import Spinner from '../../../components/Spinner';
import { getFundosGerenciados } from '../../../services/fundosGerenciadosService';
import { FundosGerenciadosData } from '../../../types/fundosGerenciados';
import TableFundos from '../components/TableFundos';
import CreateFundoModal from '../modals/CreateFundoModal';

const FundosGerenciadosPage: React.FC = () => {
  const [data, setData]                       = useState<FundosGerenciadosData[]>([]);
  const [loading, setLoading]                 = useState(true);
  const [isCreateModalOpen, setCreateModalOpen] = useState(false);

  useEffect(() => {
    getFundosGerenciados()
      .then(setData)
      .catch((e: unknown) => console.error('Error fetching fundos', e))
      .finally(() => setLoading(false));
  }, []);

  const handleNewFundoSave = (newFundo: FundosGerenciadosData) => {
    setData(prev => [...prev, newFundo]);
    setCreateModalOpen(false);
  };

  const columns = React.useMemo<ColumnDef<FundosGerenciadosData>[]>(() => [
    { header: 'CNPJ',                accessorKey: 'cnpj' },
    { header: 'Nome Fantasia',       accessorKey: 'fantasia' },
    { header: 'Classificação CVM',   accessorKey: 'classificacao_cvm' },
    { header: 'Segmento(Gestora)',   accessorKey: 'segmento_gestora' },
    { header: 'Tipo Ativo(Gestora)', accessorKey: 'tipo_ativo_gestora' },
    {
      header: 'Administrador',
      accessorKey: 'administrador',
      cell: ({ getValue }) => {
        const adm = getValue() as { sigla: string; nome: string } | null;
        return adm ? adm.sigla : '—';
      },
    },
  ], []);

  if (loading) return <Spinner />;

  return (
    <div>
      <div className="page-header">
        <h2>Fundos Gerenciados</h2>
        <IconButton onClick={() => setCreateModalOpen(true)}>
          <AddIcon />
        </IconButton>
      </div>

      <TableFundos columns={columns} data={data} />

      {isCreateModalOpen && (
        <CreateFundoModal
          isOpen={isCreateModalOpen}
          onRequestClose={() => setCreateModalOpen(false)}
          onSave={handleNewFundoSave}
        />
      )}
    </div>
  );
};

export default FundosGerenciadosPage;
